<template>
  <div class="pkg-record">
    <!-- Card Header -->
    <div class="pkg-header ts-flex ts-items-center ts-justify-between">
      <h4 class="ts-text-sm ts-font-semibold ts-text-gray-700 ts-m-0 ts-flex ts-items-center">
        <i class="fa fa-grip-vertical ts-text-gray-400 ts-mr-2 pkg-drag-handle"></i>
        <span class="ts-inline-flex ts-items-center ts-justify-center ts-rounded ts-mr-2"
          style="width:24px;height:24px;background:#e6f4ff;">
          <i class="fa fa-gift" style="color:#1890ff;font-size:11px;"></i>
        </span>
        {{ $t('promotionPackage.package') }} {{ index + 1 }}
      </h4>
      <a href="#" class="pkg-remove-btn ts-flex ts-items-center ts-space-x-1" @click.prevent="$emit('remove')">
        <i class="fa fa-trash ts-mr-1"></i>
        <span>{{ $t('remove') }}</span>
      </a>
    </div>
    <!-- Card Body -->
    <div class="ts-p-3 ts-space-y-2">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 required">
            {{ $t('promotionPackage.packageName') }}
          </label>
          <input type="text" class="form-control" v-model="model.package_name" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-ui-detail">
            <table>
              <thead>
                <tr>
                  <th width="2%" class="ts-text-center">{{ $t('no') }}</th>
                  <th width="10%">{{ $t('promotionPackage.productGroup') }}</th>
                  <th width="10%">{{ $t('promotionPackage.barcode') }}</th>
                  <th width="15%">{{ $t('promotionPackage.product') }}</th>
                  <th width="10%"> {{ $t('promotionPackage.uom') }}</th>
                  <th width="10%"> {{ $t('promotionPackage.quantity') }}</th>
                  <th width="10%">{{ $t('promotionPackage.unitPrice') }}</th>
                  <th width="10%"> {{ $t('promotionPackage.discount') }}</th>
                  <th width="10%">{{ $t('promotionPackage.discountType') }}</th>
                  <th width="10%">{{ $t('promotionPackage.total') }}</th>
                  <th width="2%" class="ts-text-center">
                    <a href="#" @click.prevent="addItem">
                      <i class="fa fa-plus"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="model.details.length == 0">
                  <td colspan="12" class="ts-text-center ts-p-3 ts-space-x-1">
                    <i class="fa fa-folder-open ts-text-gray-200"></i>
                    <label class="ts-text-gray-400">
                      {{ $t('noData') }}
                    </label>
                  </td>
                </tr>
                <tr v-for="(item, index) in model.details" :key="index">
                  <td class="ts-whitespace-no-wrap ts-text-center">
                    {{ index + 1 }}
                  </td>
                  <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                    {{ getProductGroup(item) }}
                  </td>
                  <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                    {{ getProduct(item.product_id) ? getProduct(item.product_id).barcode : 'N/A' }}
                  </td>
                  <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                    {{ getProduct(item.product_id) ? getProduct(item.product_id).product_name_en : 'N/A' }}
                  </td>
                  <td>
                    <a-select v-model="item.uom_id" :options="getUnitOfMeasures(item)" option-filter-prop="children"
                      class="ts-w-full" placeholder="Select" @change="onUomChange(item)"></a-select>
                    <div class="validate ts-text-xs" v-if="errors.has('item.' + index + '.uom_id')">
                      {{ errors.first('item.' + index + '.uom_id') }}
                    </div>
                  </td>
                  <td class="text-center ts-whitespace-no-wrap">
                    <input type="number" class="form-control ts-text-center" v-model.number="item.quantity" />
                  </td>
                  <td>
                    <ts-currency-converter-input :input_amount.sync="item.input_unit_price"
                      :amount.sync="item.unit_price" :input_currency_id.sync="item.input_currency_id"
                      :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                      :fx_rate_ratio.sync="item.fx_rate_ratio" />
                  </td>
                  <td>
                    <input v-if="item.discount_type == '%'" ref="discountRate" type="number"
                      v-model.number="item.input_discount_rate" class="form-control" @change="onChangeItem(item)" />
                    <ts-currency-converter-input v-else :input_amount.sync="item.input_discount_rate"
                      :amount.sync="item.discount_rate" :input_currency_id.sync="item.input_currency_id"
                      :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                      :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
                  </td>
                  <td>
                    <a-select v-model="item.discount_type" class="ts-w-full" style="min-width: 50px"
                      @change="onChangeItem(item)">
                      <a-select-option value="%">%</a-select-option>
                      <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                        {{ getDiscountCurrency(item.input_currency_id) }}
                      </a-select-option>
                    </a-select>
                  </td>
                  <td>
                    <ts-currency-converter-input :input_amount.sync="item.input_grand_total"
                      :amount.sync="item.grand_total" :input_currency_id.sync="item.input_currency_id"
                      :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                      :fx_rate_ratio.sync="item.fx_rate_ratio" />
                  </td>
                  <td class="text-center">
                    <a href="#" class="ts-text-red-700 hover:ts-text-red-700" @click.prevent="removeItem(index)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="background-color: #e3e8f1;">
                  <td class="ts-whitespace-no-wrap" colspan="8">
                    <b>{{ $t('promotionPackage.row') }} :
                      {{ model.details.length }}</b>
                  </td>
                  <td class="ts-whitespace-no-wrap ts-text-right">
                    <b>{{ $t('promotionPackage.subTotal') }} :</b>
                  </td>
                  <td class="ts-whitespace-no-wrap ts-text-center">
                    <ts-currency-input v-model.number="model.sub_total" class="form-control ts-text-right"
                      style="min-width: 100px;height:24px;border:transparent;" :currency="'$'" :precision="2"
                      :disabled="true" />
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <!-- show product list pop-up -->
        <a-modal v-if="show_form" v-model="show_form" :title="$t('promotion.buyProduct')" :maskClosable="false"
          :footer="null" width="900px">
          <ProductList v-model="model" />
        </a-modal>
      </div>
    </div><!-- end card body -->
  </div><!-- end card -->
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'
export default {
  name: 'packageList',
  props: ['item', 'index', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {},
    }
  },
  created() {
    this.model = this.item
  },
  computed: {
    ...mapState('promotion/promotionPackage', ['formViewDatas']),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
          .filter(p => this.filter.pro_group_id ? p.pro_group_id == this.filter.pro_group_id : true)
          .filter(p => !includes(this.model.details.map(el => el.product_id), p.product_id))
          .filter(
            p => this.filter.search
              .split(' ')
              .every(s =>
                p.barcode.toLowerCase().includes(s.toLowerCase())
              ) ||
              this.filter.search
                .split(' ')
                .every(s => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
          )
          .slice(0, 40)
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    }
  },
  methods: {
    getUnitOfMeasures(item) {
      let uom_cat_id = this.unitOfMeasures.find(el => el.value == item.uom_id).uom_cat_id

      return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
    },
    onUomChange(product) {
      const price = product.sale_code.find(el => el.uom_id == product.uom_id)
      product.input_cost = price ? price.cost : 0
      product.input_currency_id = product.currency_id
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        let currency = this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol

        return currency ? currency.currency_symbol : null
      }
      return null
    },
    onChangeItem(product) {
      if (product.discount_type == '%') {
        product.discount_rate = product.input_discount_rate
      } else {
        product.discount_type = this.getDiscountCurrency(product.input_currency_id)
        product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
      }
    },
    addItem() {
      this.show_form = true
    },
    removeItem(index) {
      const item = this.model.details[index]
      this.model.details.splice(index, 1)
    },
    getProductGroup(row) {
      let pro_group_id = null
      if (this.formViewDatas['products']) {
        pro_group_id = this.formViewDatas['products'].find(el => el.product_id == row.product_id).pro_group_id
      }
      if (this.formViewDatas['productGroups'] && pro_group_id) {
        return this.formViewDatas['productGroups'].find(el => el.pro_group_id == pro_group_id).pro_group_name_en
      }
      return 'N/A'
    },
    getProduct(product_id) {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products'].find(el => el.product_id == product_id)
      }
    },
    operatorChange(row) {
      if (row.operator_sign != 'between') {
        row.amount_to = null
        row.input_amount_to = null
      }
    },
    calculate() {
      this.model.details.forEach(el => {
        // Handle percentage-based discount
        el.sub_total = el.unit_price * el.quantity;
        el.input_sub_total = el.sub_total * el.fx_rate_ratio;

        if (el.discount_type === '%') {
          el.discount_rate = el.input_discount_rate;

          el.discount_amount = (el.sub_total * el.input_discount_rate) / 100;
          el.input_discount_amount = el.discount_amount * el.fx_rate_ratio;
        } else {
          // Handle flat discount
          el.discount_type = this.getDiscountCurrency(el.input_currency_id);
          el.discount_rate = el.input_discount_rate * el.fx_rate_ratio;

          el.discount_amount = el.discount_rate;
          el.input_discount_amount = el.discount_amount * el.fx_rate_ratio;
        }

        const uom = this.unitOfMeasures.find(uom => uom.value == el.uom_id)

        el.stock_quantity = uom.stockout_quantity * el.quantity;

        // Calculate VAT
        el.vat_amount = (el.sub_total - el.discount_amount) * (el.vat_rate / 100);
        el.input_vat_amount = el.vat_amount * el.fx_rate_ratio;

        // Calculate grand total
        el.grand_total = (el.sub_total - el.discount_amount) + el.vat_amount;
        el.input_grand_total = el.grand_total * el.fx_rate_ratio;
      });

      this.model.sub_total = _.sumBy(this.model.details, function (el) {
        return el.grand_total
      });


      // this.model.invoice_amount = _.sumBy(this.model.product_details, function (el) {
      //   return el.grand_total
      // })
    },
  },
  watch: {
    'model.details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>

<style scoped>
.pkg-record {
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.pkg-record:last-child {
  margin-bottom: 0;
}

.pkg-header {
  padding: 10px 16px;
  background: #fafafa;
}

.pkg-drag-handle {
  cursor: grab;
}

.pkg-drag-handle:active {
  cursor: grabbing;
}

.pkg-remove-btn {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: #ff4d4f;
  border-radius: 4px;
  padding: 2px 10px;
  text-decoration: none;
  transition: background 0.2s;
}

.pkg-remove-btn:hover {
  background: #d9363e;
  color: #fff;
}
</style>